import PropTypes from 'prop-types';

// import classNames from 'classnames';
// import { formWidth } from './index';

const defaultProps = {
  label: null
};

const propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  label: PropTypes.string
};

const StaticField = (props) => {
  const { input, label, onClick } = props;
  return (
    <div>
      <div className="c7-label-sudo">{label}</div>
      {renderValue(input, onClick)}
    </div>
  );
};

const renderValue = (input, onClick) => {
  if (onClick) {
    return (
      <div className="c7-input-sudo">
        <a onClick={onClick}>{input.value}</a>
      </div>
    );
  }
  return <p>{input.value}</p>;
};

StaticField.propTypes = propTypes;
StaticField.defaultProps = defaultProps;

export default StaticField;
